import { State } from '../context';

export const getOwnerId = (state: State) => state.metadata.ownerId;
export const getRecipientId = (state: State) => state.metadata.recipientId;
export const getProposalId = (state: State) => state.metadata.id;
export const getProposalStatusId = (state: State) => state.metadata.statusId;
export const getIsProposalArchived = (state: State) => state.metadata.archived === 1;
